import { Component, OnInit, Input } from '@angular/core';
import { Itinerary } from '../../core';
import { ProfileService, ItinerariesService } from 'core/services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lms-itinerary-translations',
  templateUrl: './itinerary-translations.component.html',
  styleUrls: ['./itinerary-translations.component.scss']
})
export class ItineraryTranslationsComponent implements OnInit {
  @Input() itinerary: Itinerary;
  public translations: Array<any> = [];
  public selectedTranslation: string = null;
  public onEdit: boolean = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public itinerariesService: ItinerariesService,
    public profileService: ProfileService
  ) {}

  public ngOnInit(): void {
    this.itinerariesService.getItineraryTranslations(this.itinerary.id).then((itineraryTranslations: any) => {
      const { translations } = itineraryTranslations;
      this.translations = translations;
    });
  }

  public selectTranslation(translation?: any): void {
    this.selectedTranslation = translation || null;
    this.onEdit = true;
  }

  public onUpdateTranslations(res: any): void {
    this.translations = res.translations;
    this.cancel();
  }

  public cancel(): void {
    this.onEdit = false;
    this.selectedTranslation = null;
  }
}
